import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// Premium toast styling: frosted-glass base + a coloured 3px left
// border per intent. Reads as brand-aware without being noisy.
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: [
            "group toast",
            "group-[.toaster]:bg-background/85 group-[.toaster]:backdrop-blur-xl",
            "group-[.toaster]:text-foreground",
            "group-[.toaster]:border group-[.toaster]:border-border",
            "group-[.toaster]:shadow-[0_8px_28px_-6px_rgba(0,0,0,0.18)]",
            "group-[.toaster]:rounded-xl",
          ].join(" "),
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted-bg group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:border-l-[3px] group-[.toaster]:border-l-[hsl(var(--ok))]",
          error: "group-[.toaster]:border-l-[3px] group-[.toaster]:border-l-[hsl(var(--error))]",
          warning: "group-[.toaster]:border-l-[3px] group-[.toaster]:border-l-[hsl(var(--warn))]",
          info: "group-[.toaster]:border-l-[3px] group-[.toaster]:border-l-[hsl(var(--brand))]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
